import { Form, Spinner } from 'react-bootstrap';
import Layout2 from '../layouts/Layout2';
import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import '../App.css';

const CreditPaidTransaction = () => {
    const endpointURL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE;
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    
    const handleSearch = (e) => {
        e.preventDefault();
        fetchData();
    }
    
    const fetchData = async () => {
        setIsLoading(true);
        const paramArray = {
            "from": from,
            "to": to
        };
        try {
            const response = await fetch(endpointURL + "/api/v1/getPaidCredit", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                },
                body: JSON.stringify(paramArray),
            });
            if (!response.ok) {
                console.log("error resp");
            }
            const result = await response.json();
            if (result.status == true) {
                setFrom(result.date.from);
                setTo(result.date.to);
                setData(result.data);
            } else {
                console.log("response fail");
            }
        } catch (error) {
            console.log("error catch")
        }
        setIsLoading(false);
    }
    
    const viewTransaction = (data) => {
        navigate('/transaction-view', { state: data });
    }
    
    useEffect(() => {
        if (localStorage.getItem('token') == null || localStorage.getItem('token') == "") {
            Swal.fire({
                text: "Telegram ဖြင့် Login ဝင်ပါ",
                width: 400,
            });
            navigate("/");
        }
        fetchData();
    }, []);
    
    return (
        <>
            <Layout2 pageType="အကြွေးဆပ်စာရင်း">
                <Helmet>
                    <title>အကြွေးဆပ်စာရင်းများ</title>
                </Helmet>
                <div className="credit-paid-container">
                    <Form className="transaction-search-form" onSubmit={handleSearch}>
                        <div className="transaction-form-row">
                            <Form.Group className="transaction-form-group">
                                <Form.Label className="transaction-label">From:</Form.Label>
                                <Form.Control
                                    type="date"
                                    defaultValue={from}
                                    onChange={(e) => setFrom(e.target.value)}
                                    className="transaction-input"
                                />
                            </Form.Group>
                            <Form.Group className="transaction-form-group">
                                <Form.Label className="transaction-label">To:</Form.Label>
                                <Form.Control
                                    type="date"
                                    defaultValue={to}
                                    onChange={(e) => setTo(e.target.value)}
                                    className="transaction-input"
                                />
                            </Form.Group>
                        </div>
                        <Form.Group style={{ textAlign: 'center' }}>
                            <button className="transaction-search-btn" type="submit">
                                <i className='lni lni-search'></i>
                                ရှာမည်
                            </button>
                        </Form.Group>
                    </Form>

                    <div className="credit-paid-header">
                        <h6>အကြွေးဆပ်စာရင်းများ</h6>
                    </div>

                    {
                        isLoading ?
                            <div className="transaction-loading">
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                                <p>လုပ်ဆောင်နေသည်...ခဏစောင့်ပါ</p>
                            </div>
                            :
                            data.length > 0 ?
                                <div className="credit-paid-list">
                                    {data.map((list) => (
                                        <div key={list.id} className="credit-paid-item">
                                            <div className="credit-paid-content">
                                                <div className="credit-paid-info">
                                                    <div className="credit-paid-date">{list.date} {list.time}</div>
                                                    <div className="credit-paid-amount">
                                                        {
                                                            list.paid_image === "paidByWallet" ? list.now_paid_credit_amount :
                                                            list.now_paid_credit_amount === 0 ? list.amount :
                                                            list.paid_image === "Owner" ? list.now_paid_credit_amount :
                                                            list.amount
                                                        }
                                                    </div>
                                                    <div className={`credit-paid-type ${list.paid_image === "Owner" ? "owner" : list.paid_image === "paidByWallet" ? "wallet" : ""}`}>
                                                        {
                                                            list.paid_image === "Owner" ?
                                                                "Owner ဘက်မှဆပ်ပေးတာ" :
                                                                list.paid_image === "paidByWallet" ?
                                                                    "Owner ဘက်မှ Credit ထဲမှဆပ်ပေးတာ" :
                                                                    <a href={endpointURL + `/storage/${list.paid_image}`} target="_blank" className="credit-paid-receipt-link" rel="noopener noreferrer">
                                                                        <i className="lni lni-receipt"></i>
                                                                        အကြွေးဆပ်ပြေစာ
                                                                    </a>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                :
                                <div className="credit-paid-empty">
                                    <i className="lni lni-empty-file"></i>
                                    <p>အကြွေးဆပ်စာရင်းမရှိပါ...</p>
                                </div>
                    }
                </div>
            </Layout2>
        </>
    );
}

export default CreditPaidTransaction;